import React, { useRef, useEffect, useState, useContext, useCallback } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import { AppContext } from "../../Context/AppContext";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  clearInputBtn: {
    fontSize: ".8em",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1em",
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {},
  },
  grow: {
    flexGrow: 1,
  },
  productListPaper: {
    marginBottom: 50,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "right",
    color: theme.palette.text.secondary,
  },
}));

const materialTheme = createTheme({
  // set default for now
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const filter = createFilterOptions();

function InputSalesInvoices(props) {
  const classes = useStyles();

  const { companyId } = useContext(AppContext);
  const [searchProductTerm, setSearchProductTerm] = useState({ name: "" });
  const [autoSuggestProducts, setAutoSuggestProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [totalInvoicedAmount, setTotalInvoicedAmount] = useState(0);
  const [invoicedItemCount, setInvoicedItemCount] = useState(0);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");
  const [isLoading, setIsLoading] = useState(true);
  const [openLotNumberAndExpirationDialogInput, setOpenLotNumberAndExpirationDialogInput] =
    useState(true);
  const [selectedProductForLotNumberInput, setSelectedProductForLotNumberInput] = useState(null);

  const [hasMoreProductToLoad, setHasMoreProductToLoad] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadProducts, setLoadProducts] = useState(true);
  const lastProductElementObserver = useRef();

  const lastProductElement = useCallback(
    (node) => {
      if (isLoading) {
        return;
      }
      if (lastProductElementObserver.current) {
        lastProductElementObserver.current.disconnect();
      }
      lastProductElementObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreProductToLoad) {
          lastProductElementObserver.current.disconnect();
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
          setLoadProducts(true);
        }
      });

      if (node) {
        lastProductElementObserver.current.observe(node);
      }
    },
    [isLoading]
  );

  const onOrderOrPriceInputOnChange = (product, unit) => (event) => {
    const productsCopy = [...products];

    if (event.target.name === "quantity") {
      const orderQuantity = event.target.value;
      unit.order_quantity =
        orderQuantity.length <= 0 || isNaN(orderQuantity) ? 0 : parseFloat(orderQuantity).toFixed();
    } else if (event.target.name === "price") {
      const newPriceWithTax = event.target.value;
      unit.new_price_with_tax =
        newPriceWithTax.length <= 0 || isNaN(newPriceWithTax)
          ? 0
          : parseFloat(newPriceWithTax).toFixed(2);
    }
    saveOrDeleteLocalStorageTempOrder(product);

    setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
    setInvoicedItemCount(totalInvoicedCount());
    product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);

    setProducts(productsCopy);
  };
  const priceInputOnBlur = (product, unit) => (event) => {
    const currentPrice = unit.current_price_with_tax;
    const newPrice = unit.new_price_with_tax == null ? 0 : unit.new_price_with_tax;

    if (newPrice != null && newPrice.length > 0 && newPrice > 0) {
      return;
    }
    if (currentPrice == null) {
      return;
    }

    const productsCopy = [...products];
    unit.new_price_with_tax = currentPrice;

    saveOrDeleteLocalStorageTempOrder(product);

    setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
    setInvoicedItemCount(totalInvoicedCount());
    product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);

    setProducts(productsCopy);
  };
  const clearInputClickListener = (event) => {
    localStorage.removeItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    props.closeThenOpenInputDialog();
  };

  function saveOrDeleteLocalStorageTempOrder(product) {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );

    if (temporarySalesInvoiceString == null) {
      localStorage.setItem(
        props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice",
        JSON.stringify([product])
      );
      return;
    }
    const temporarySalesInvoiceJSON = JSON.parse(temporarySalesInvoiceString);
    const index = temporarySalesInvoiceJSON.findIndex(
      (salesInvoiceProduct) =>
        salesInvoiceProduct.code == product.code &&
        salesInvoiceProduct.company_id == product.company_id
    );
    const hasQuantityOrPriceInput = doProductHasQuantityOrPriceInput(product);

    if (index >= 0) {
      //replace or remove
      if (hasQuantityOrPriceInput == true) {
        temporarySalesInvoiceJSON.splice(index, 1, product); //replace object
      } else if (hasQuantityOrPriceInput == false) {
        temporarySalesInvoiceJSON.splice(index, 1); //remove object
      }
    } else {
      //add
      if (hasQuantityOrPriceInput == true) {
        temporarySalesInvoiceJSON.push(product);
      }
    }

    if (temporarySalesInvoiceJSON.length <= 0) {
      localStorage.removeItem(
        props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
      );
    } else {
      localStorage.setItem(
        props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice",
        JSON.stringify(temporarySalesInvoiceJSON)
      );
    }
  }
  function doProductHasQuantityOrPriceInput(product) {
    for (let x = 0; x < product.Units.length; x++) {
      const unit = product.Units[x];
      const orderQuantity =
        unit.order_quantity != null && unit.order_quantity.length > 0
          ? Number(unit.order_quantity)
          : 0;
      const priceWithTax =
        unit.new_price_with_tax != null && unit.new_price_with_tax.length > 0
          ? Number(unit.new_price_with_tax)
          : 0;

      if (orderQuantity > 0 || priceWithTax > 0) {
        return true;
      }
    }

    return false;
  }
  function computeTotalInvoiceAmountPerProduct(product) {
    const totalInvoiceValue = Number(
      product.Units.reduce((partialSum, unit) => {
        const priceWithTax =
          unit.new_price_with_tax && unit.new_price_with_tax !== 0
            ? unit.new_price_with_tax
            : unit.current_price_with_tax;

        const amount = parseFloat(unit.order_quantity) * priceWithTax;
        return partialSum + (isNaN(amount) ? 0 : amount);
      }, 0.0)
    );

    return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue;
  }

  function computeOverallTotalInvoiceAmount() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }
    const temporarySaleInvoiced = JSON.parse(temporarySalesInvoiceString);
    const overallTotalAmount = temporarySaleInvoiced
      .reduce(
        (partialSum, product) => partialSum + computeTotalInvoiceAmountPerProduct(product),
        0.0
      )
      .toFixed(2);

    return overallTotalAmount;
  }
  function totalInvoicedCount() {
    const temporarySalesInvoiceString = localStorage.getItem(
      props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
    );
    if (temporarySalesInvoiceString == null) {
      return 0;
    }

    const jsonTemporarySalesInvoiceString = JSON.parse(temporarySalesInvoiceString);

    const totalProductUnitWithOrder = jsonTemporarySalesInvoiceString.reduce(
      (partialSum, product) => {
        const totalUnitWithQuantity = product.Units.reduce((unitWithQuantityPartialPrice, unit) => {
          const orderQuantity = unit.order_quantity == null ? 0 : unit.order_quantity;

          if (!isNaN(orderQuantity) && orderQuantity.length > 0 && orderQuantity > 0) {
            return unitWithQuantityPartialPrice + 1;
          }
          return unitWithQuantityPartialPrice;
        }, 0);

        return partialSum + totalUnitWithQuantity;
      },
      0
    );

    return totalProductUnitWithOrder;
  }
  function invoicedQuantity(unit) {
    return unit.order_quantity <= 0 ? "" : unit.order_quantity;
  }
  function priceWithTaxValue(unit) {
    let price = 0;

    if (
      unit.new_price_with_tax == null ||
      unit.new_price_with_tax.length <= 0 ||
      parseFloat(unit.new_price_with_tax) <= 0
    ) {
      price = parseFloat(unit.current_price_with_tax);
    } else {
      price = parseFloat(unit.new_price_with_tax);
    }

    return price;
  }
  function getProductSmallestUOM(uoms) {
    if (uoms.length <= 0) {
      return "";
    }

    return uoms[0].uom;
  }
  function totalInvoicedQuantityInSmallestUOM(uoms) {
    return uoms
      .reduce(
        (partialSum, uom) =>
          partialSum +
          (uom.order_quantity == null ? 0 : uom.order_quantity * uom.converted_to_smallest_value),
        0.0
      )
      .toFixed(2);
  }
  function getProductUomObjectByUnit(uomsObjects, uomString) {
    return uomsObjects.filter(function (uomObject) {
      return uomObject.uom == uomString;
    })[0];
  }
  function getSmallestUom(uoms) {
    return uoms.filter(function (uom) {
      return uom.converted_to_smallest_value == 1;
    })[0];
  }
  function getConversionForViewing(uoms, smallestUOMString) {
    return (
      <React.Fragment>
        <small>Conversion:</small>
        <List style={{ margin: "0px" }}>
          {uoms.map((unit) => (
            <ListItem style={{ padding: "0px", paddingLeft: "1rem" }}>
              <ListItemText
                primary={` 1 ${unit.uom} = ${unit.converted_to_smallest_value} ${smallestUOMString}`}
              />
            </ListItem>
          ))}
        </List>
      </React.Fragment>
    );
  }
  function computeTotalLotNumberAndExpirationServed(selectedProductForLotNumberInput) {
    return selectedProductForLotNumberInput.LotNumberAndExpirationInventories.reduce(
      (partial, lotNumberAndExpirationInventory) => {
        if (lotNumberAndExpirationInventory.hasOwnProperty("invoiced_quantity")) {
          return partial + lotNumberAndExpirationInventory.invoiced_quantity;
        } else {
          return partial;
        }
      },
      0
    );
  }
  function getInvoicedLotNumberAndExpirationByProductCodeAndUnitAndLotNumber(
    productCode,
    unitOfMeasure,
    lotNumber
  ) {
    const tempInvoicedLotNumberAndExpirationString = localStorage.getItem(
      props.selectedSalesOrder.Account.auto_generated_id +
        "_temp_invoiced_lot_number_and_expiration"
    );
    if (tempInvoicedLotNumberAndExpirationString == null) {
      return 0;
    }

    const tempInvoicedLotNumberAndExpirationJSON = JSON.parse(
      tempInvoicedLotNumberAndExpirationString
    );

    const index = tempInvoicedLotNumberAndExpirationJSON.findIndex((lotNumberAndExpiration) => {
      return (
        lotNumberAndExpiration.lot_number == lotNumber &&
        lotNumberAndExpiration.product_code == productCode &&
        lotNumberAndExpiration.unit == unitOfMeasure
      );
    });

    if (index < 0) {
      return 0;
    } else {
      return tempInvoicedLotNumberAndExpirationJSON[index].invoiced_quantity_in_smallest_uom;
    }
  }
  /**
   * Get total invoiced lot number and expiration not included unit
   * @param {*} productCode
   * @param {*} lotNumber
   * @param {*} unit = not included unit in computation
   */
  function getTotalInvoicedLotNumberAndExpirationByProductInSmallestUOM(productCode) {
    const tempInvoicedLotNumberAndExpirationString = localStorage.getItem(
      props.selectedSalesOrder.Account.auto_generated_id +
        "_temp_invoiced_lot_number_and_expiration"
    );
    if (tempInvoicedLotNumberAndExpirationString == null) {
      return 0;
    }

    const tempInvoicedLotNumberAndExpirationJSON = JSON.parse(
      tempInvoicedLotNumberAndExpirationString
    );

    return tempInvoicedLotNumberAndExpirationJSON.reduce(
      (partial, tempInvoicedLotNumberAndExpiration) => {
        if (tempInvoicedLotNumberAndExpiration.product_code == productCode) {
          return partial + tempInvoicedLotNumberAndExpiration.invoiced_quantity_in_smallest_uom;
        } else {
          return partial + 0;
        }
      },
      0
    );
  }

  const lotNumberAndExpirationInfoInputOnChange =
    (selectedProductForLotNumberInput, lotNumberAndExpirationInventory, unit) => (event) => {
      const value = event.target.value.length <= 0 ? 0 : parseInt(event.target.value);
      const lotNumber = lotNumberAndExpirationInventory.lot_number;
      const expirationDate = lotNumberAndExpirationInventory.expiration_date;
      const productCode = lotNumberAndExpirationInventory.product_code;
      const unitOfMeasure = unit.uom;

      const totalInvoicedInSmallestUOM = totalInvoicedQuantityInSmallestUOM(
        selectedProductForLotNumberInput.Units
      );
      const currentTotalLotNumberAndExpirationInvoicedInSmallestUOM =
        getTotalInvoicedLotNumberAndExpirationByProductInSmallestUOM(productCode);
      const currentlySelectedUnitLotNumberProductInvoicedQuantity =
        getInvoicedLotNumberAndExpirationByProductCodeAndUnitAndLotNumber(
          productCode,
          unitOfMeasure,
          lotNumber
        );
      const currentProductTotalLotNumberAndExpirationInvoicedInSmallestUOMLessSelected =
        currentTotalLotNumberAndExpirationInvoicedInSmallestUOM -
        currentlySelectedUnitLotNumberProductInvoicedQuantity;
      const convertionInSmallestUOM = unit.converted_to_smallest_value;
      const currentValuelotNumberAndExpirationInvoicedInSmallestUOM =
        convertionInSmallestUOM * value;

      if (
        currentValuelotNumberAndExpirationInvoicedInSmallestUOM +
          currentProductTotalLotNumberAndExpirationInvoicedInSmallestUOMLessSelected >
        totalInvoicedInSmallestUOM
      ) {
        return;
      }

      const invoicedQuantityPerUom = {
        lot_number: lotNumber,
        product_code: productCode,
        expiration_date: expirationDate,
        invoiced_quantity: value,
        invoiced_quantity_in_smallest_uom: currentValuelotNumberAndExpirationInvoicedInSmallestUOM,
        unit: unitOfMeasure,
      };

      const tempInvoicedLotNumberAndExpirationString = localStorage.getItem(
        props.selectedSalesOrder.Account.auto_generated_id +
          "_temp_invoiced_lot_number_and_expiration"
      );
      if (tempInvoicedLotNumberAndExpirationString == null) {
        localStorage.setItem(
          props.selectedSalesOrder.Account.auto_generated_id +
            "_temp_invoiced_lot_number_and_expiration",
          JSON.stringify([invoicedQuantityPerUom])
        );
        return;
      }

      const tempInvoicedLotNumberAndExpirationJSON = JSON.parse(
        tempInvoicedLotNumberAndExpirationString
      );
      const index = tempInvoicedLotNumberAndExpirationJSON.findIndex((lotNumberAndExpiration) => {
        return (
          lotNumberAndExpiration.lot_number == lotNumber &&
          lotNumberAndExpiration.product_code == productCode &&
          lotNumberAndExpiration.unit == unitOfMeasure
        );
      });

      if (index >= 0 && value > 0) {
        //replace
        tempInvoicedLotNumberAndExpirationJSON.splice(index, 1, invoicedQuantityPerUom);
      } else if (index >= 0 && value <= 0) {
        //delete
        tempInvoicedLotNumberAndExpirationJSON.splice(index, 1); //remove object
      } else {
        //save
        tempInvoicedLotNumberAndExpirationJSON.push(invoicedQuantityPerUom);
      }
      localStorage.setItem(
        props.selectedSalesOrder.Account.uto_generated_id +
          "_temp_invoiced_lot_number_and_expiration",
        JSON.stringify(tempInvoicedLotNumberAndExpirationJSON)
      );

      const selectedProductForLotNumberInputCopy = {
        ...selectedProductForLotNumberInput,
      };
      setSelectedProductForLotNumberInput(selectedProductForLotNumberInputCopy);
    };
  function getLotNumberAndExpirationInvoicedPerLotNumber(productCode, unitOfMeasure, lotNumber) {
    const tempInvoicedLotNumberAndExpirationString = localStorage.getItem(
      props.selectedSalesOrder.Account.auto_generated_id +
        "_temp_invoiced_lot_number_and_expiration"
    );
    if (tempInvoicedLotNumberAndExpirationString == null) {
      return "";
    }

    const tempInvoicedLotNumberAndExpirationJSON = JSON.parse(
      tempInvoicedLotNumberAndExpirationString
    );
    const index = tempInvoicedLotNumberAndExpirationJSON.findIndex((lotNumberAndExpiration) => {
      return (
        lotNumberAndExpiration.lot_number == lotNumber &&
        lotNumberAndExpiration.product_code == productCode &&
        lotNumberAndExpiration.unit == unitOfMeasure
      );
    });

    if (index < 0) {
      return "";
    }
    const tempInvoicedLotNumberAndExpirationObject = tempInvoicedLotNumberAndExpirationJSON[index];
    const invoicedQuantity = tempInvoicedLotNumberAndExpirationObject.invoiced_quantity;

    if (invoicedQuantity <= 0) {
      return "";
    } else {
      return invoicedQuantity;
    }
  }
  function lotNumberAndExpirationInfoAndInfo(
    selectedProductForLotNumberInput,
    lotNumberAndExpirationInventory
  ) {
    return (
      <React.Fragment>
        <List>
          {selectedProductForLotNumberInput.Units.map((unit) => {
            return (
              <div>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
                    <Grid container spacing={1}>
                      <Grid item style={{ display: "inline-grid", alignItems: "center" }}>
                        <Typography
                          variant="h6"
                          component="span"
                          style={{ fontWeight: 600, fontSize: "16px" }}
                        >
                          <small>{unit.uom}</small>
                        </Typography>
                      </Grid>
                      <Grid item style={{ marginTop: ".5em" }}>
                        <TextField
                          autoComplete="off"
                          name="quantity"
                          type="number"
                          label="Quantity"
                          variant="outlined"
                          style={{ width: "100%" }}
                          value={getLotNumberAndExpirationInvoicedPerLotNumber(
                            selectedProductForLotNumberInput.code,
                            unit.uom,
                            lotNumberAndExpirationInventory.lot_number
                          )}
                          onChange={lotNumberAndExpirationInfoInputOnChange(
                            selectedProductForLotNumberInput,
                            lotNumberAndExpirationInventory,
                            unit
                          )}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                    </Grid>
                  </ThemeProvider>
                </StyledEngineProvider>
              </div>
            );
          })}
        </List>
      </React.Fragment>
    );
  }
  function lotNumberAndExpirationDisplayWithInput(
    selectedProductForLotNumberInput,
    smallestUOMString
  ) {
    return (
      <React.Fragment>
        <List>
          {selectedProductForLotNumberInput.LotNumberAndExpirationInventories.map(
            (lotNumberAndExpirationInventory) => {
              return (
                <ListItem divider>
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="p">
                        {`Lot # : ${lotNumberAndExpirationInventory.lot_number}`}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="p">
                        {`Exp date : ${lotNumberAndExpirationInventory.expiration_date}`}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" component="p">
                        {`Available: ${lotNumberAndExpirationInventory.quantity} ${smallestUOMString}`}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {lotNumberAndExpirationInfoAndInfo(
                        selectedProductForLotNumberInput,
                        lotNumberAndExpirationInventory
                      )}
                    </Grid>
                  </Grid>
                </ListItem>
              );
            }
          )}
        </List>
      </React.Fragment>
    );
  }
  function lotNumberAndExpirationInputDialog() {
    if (selectedProductForLotNumberInput == null) {
      return "";
    }

    const smallestUOM = getSmallestUom(selectedProductForLotNumberInput.Units);
    const smallestUOMString = smallestUOM.uom;
    const totalInvoicedInSmallestUOM = totalInvoicedQuantityInSmallestUOM(
      selectedProductForLotNumberInput.Units
    );

    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          <Dialog
            open={openLotNumberAndExpirationDialogInput}
            onClose={() => {
              setOpenLotNumberAndExpirationDialogInput(false);
              setSelectedProductForLotNumberInput(null);
            }}
            fullWidth={true}
            maxWidth="md"
          >
            <DialogContent style={{ padding: ".4rem" }}>
              <Typography variant="h6" style={{ color: "black" }} gutterBottom>
                {selectedProductForLotNumberInput.name}
              </Typography>
              {getConversionForViewing(selectedProductForLotNumberInput.Units, smallestUOMString)}
              <Typography variant="subtitle1" gutterBottom>
                <small>Invoiced quantity :</small> {totalInvoicedInSmallestUOM} {smallestUOMString}
              </Typography>

              {lotNumberAndExpirationDisplayWithInput(
                selectedProductForLotNumberInput,
                smallestUOMString
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenLotNumberAndExpirationDialogInput(false);
                }}
                color="primary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
  function messageDialog() {
    return (
      <Dialog
        fullWidth
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  function orderInput(product, unit) {
    return (
      <div>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            <Grid container spacing={1}>
              <Grid
                item
                xs={2}
                style={{
                  display: "inline-grid",
                  justifyItems: "right",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  component="span"
                  style={{ fontWeight: 600, fontSize: "16px" }}
                >
                  <small>{unit.uom}</small>
                </Typography>
              </Grid>
              <Grid item xs={5} style={{ marginTop: ".5em" }}>
                <TextField
                  autoComplete="off"
                  name="quantity"
                  type="number"
                  label="Quantity"
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={invoicedQuantity(unit)}
                  onChange={onOrderOrPriceInputOnChange(product, unit)}
                  InputLabelProps={{ shrink: true }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={5} style={{ marginTop: ".5em" }}>
                <TextField
                  autoComplete="off"
                  name="price"
                  type="number"
                  label="Price"
                  variant="outlined"
                  style={{ width: "100%" }}
                  onBlur={priceInputOnBlur(product, unit)}
                  value={priceWithTaxValue(unit)}
                  onChange={onOrderOrPriceInputOnChange(product, unit)}
                  InputLabelProps={{ shrink: true }}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
            </Grid>
          </ThemeProvider>
        </StyledEngineProvider>
      </div>
    );
  }

  function productElement(product) {
    return (
      <Grid container style={{ padding: "0px" }}>
        <Grid container item xs={12}>
          <Grid item xs={12} md={12} lg={12}>
            <Grid container direction="column" justifyContent="space-between" alignItems="stretch">
              <Grid
                item
                container
                onClick={() => {
                  setSelectedProductForLotNumberInput(product);
                  setOpenLotNumberAndExpirationDialogInput(true);
                }}
              >
                <Grid item xs container direction="column" justifyContent="center">
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                  <Box style={{ fontWeight: 600, fontSize: "14px" }}>
                    {product.short_name != "" ? product.short_name : product.name}
                  </Box>
                  <Box>
                    {product.short_name && (
                      <Typography variant="caption">{product.name}</Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item>
                  <IconButton component="span" style={{ height: "100%" }} size="large">
                    <MoreVertIcon />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid item>
                {product.Units.map((unit) => (
                  <React.Fragment key={unit.id}>{orderInput(product, unit)}</React.Fragment>
                ))}
              </Grid>
              <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>
                Total: ₱
                {product.total_invoiced_amount != null
                  ? product.total_invoiced_amount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "0.00"}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function productLists() {
    return (
      <List>
        {products.map((product, index) =>
          products.length === index + 1 ? (
            <React.Fragment key={product.id}>
              <ListItem ref={lastProductElement} divider>
                {productElement(product)}
              </ListItem>
            </React.Fragment>
          ) : (
            <React.Fragment key={product.id}>
              <ListItem divider>{productElement(product)}</ListItem>
            </React.Fragment>
          )
        )}
      </List>
    );
  }

  function search() {
    return (
      <div
        position="static"
        style={{
          border: ".1rem solid #989898",
          borderRadius: "4px",
          margin: "2px",
        }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                setProducts([]);
                setPageNumber(1);
                setLoadProducts(true);
                //fetchProducts(searchProductTerm.name)
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }
  function autoComplete() {
    return (
      <Autocomplete
        value={searchProductTerm}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue == null || newValue.name === "") {
            //searchProductTerm.name = ""
            setSearchProductTerm({ name: "" });
            return;
          }
          const searchValue =
            newValue.short_name && newValue.short_name !== "" ? newValue.short_name : newValue.name;
          setSearchProductTerm({ name: searchValue });

          setProducts([]);
          setPageNumber(1);
          setLoadProducts(true);

          //fetchProducts(newValue.name)
        }}
        filterOptions={(options, { inputValue }) => {
          if (!inputValue.trim()) return options;
          const searchTerm = inputValue.toLowerCase();
          return options.filter(
            ({ name, short_name }) =>
              name.toLowerCase().includes(searchTerm) ||
              short_name.toLowerCase().includes(searchTerm)
          );
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestProducts}
        getOptionLabel={(option) => {
          return option.name;
        }}
        isOptionEqualToValue={() => true}
        renderOption={(props, option) => (
          <React.Fragment key={option.id}>
            <Box component="li" {...props} sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1" fontWeight="bold">
                  {option.short_name && option.short_name !== "" ? option.short_name : option.name}
                </Typography>
                {option.short_name && <Typography variant="caption">{option.name}</Typography>}
              </Box>
            </Box>
            <Divider />
          </React.Fragment>
        )}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            variant="standard"
            {...params}
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchProductTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }

  function getOrderPerProductInLocalStorage(temporarySalesInvoice, product) {
    const tempSalesInvoicedIndex = temporarySalesInvoice.findIndex(
      (tempOrder) => tempOrder.code == product.code && tempOrder.company_id == product.company_id
    );

    if (tempSalesInvoicedIndex >= 0) {
      product.Units.forEach((unit, index) => {
        const tempSalesInvoiceUnit = temporarySalesInvoice[tempSalesInvoicedIndex].Units[index];

        if (tempSalesInvoiceUnit !== undefined) {
          unit.order_quantity = tempSalesInvoiceUnit.order_quantity;
          unit.new_price_with_tax = tempSalesInvoiceUnit.new_price_with_tax;
        }
      });
    }
  }

  function fetchAutoSuggestProducts(searchString) {
    const loadProducts = async () => {
      setAutoCompleteSearchOptionMessage("Searching");
      const salesOrderAutoGeneratedId = props.selectedSalesOrder.auto_generated_id;
      const salesOrderId = props.selectedSalesOrder.id;
      const options = {
        method: "POST",
        url: "/TransactiSellerProducts/getProductsForAutoSuggest.json",
        data: objectToFormData({
          company_id: companyId,
          sales_order_id: salesOrderId,
          sales_order_auto_generated_id: salesOrderAutoGeneratedId,
          search_term: searchString,
        }),
      };
      const response = await axios(options)
        .then((res) => {
          const products = res.data.products;

          if (products.length <= 0) {
            setAutoCompleteSearchOptionMessage("No record found.");
            setAutoSuggestProducts([]);
          } else {
            setAutoSuggestProducts(products);
          }
        })
        .catch((error) => {});
    };
    loadProducts();
  }

  useEffect(() => {
    if (props.openInputDialog == false) {
      setProducts([]);
      return;
    }

    fetchProducts(searchProductTerm.name);
  }, [props.openInputDialog, loadProducts]);

  useEffect(() => {
    if (searchProductTerm == null) {
      fetchAutoSuggestProducts("");
    } else {
      fetchAutoSuggestProducts(searchProductTerm.name);
    }
  }, [searchProductTerm, loadProducts]);

  function fetchProducts(searchTerm) {
    setIsLoading(true);

    const accountId = props.selectedSalesOrder.Account.id;
    var accountCode = props.selectedSalesOrder.Account.account_code;

    if (props.selectedSalesOrder.Account.account_code === undefined) {
      accountCode = props.selectedSalesOrder.account_code;
    }

    const salesOrderAutoGeneratedId = props.selectedSalesOrder.auto_generated_id;
    const salesOrderId = props.selectedSalesOrder.id;

    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/getProductsForTransactiSellerOrderInvoicing.json",
      data: objectToFormData({
        sales_order_id: salesOrderId,
        sales_order_auto_generated_id: salesOrderAutoGeneratedId,
        account_id: accountId,
        account_code: accountCode,
        seller_company_id: companyId,
        search_term: searchTerm,
        page_number: pageNumber,
      }),
    };
    axios(options)
      .then((res) => {
        setLoadProducts(false);
        setIsLoading(false);

        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");

          // setIsSavingSuccess(false)
          // setIsSavingAccount(false)
          // setMessageDialogMessage(res.data.response.message)
          // setShowMessageDialog(true)

          return;
        }
        const productFromServer = res.data.response.products;
        const temporarySalesInvoiceString = localStorage.getItem(
          props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
        );

        setHasMoreProductToLoad(productFromServer.length > 0);

        // if(temporarySalesInvoiceString == null){

        //   setProducts(products.concat(productFromServer))
        //   setTotalInvoicedAmount(computeOverallTotalInvoiceAmount())
        //   setInvoicedItemCount(totalInvoicedCount())

        //   return
        // }

        const temporarySalesInvoice = JSON.parse(temporarySalesInvoiceString);

        productFromServer.forEach((product, index) => {
          if (temporarySalesInvoiceString != null) {
            getOrderPerProductInLocalStorage(temporarySalesInvoice, product);
          }

          product.total_invoiced_amount = computeTotalInvoiceAmountPerProduct(product);
          saveOrDeleteLocalStorageTempOrder(product);
        });

        setTotalInvoicedAmount(computeOverallTotalInvoiceAmount());
        setInvoicedItemCount(totalInvoicedCount());

        setProducts(products.concat(productFromServer));
      })
      .catch((error) => {
        setIsLoading(false);
        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  return (
    <div>
      <Dialog
        fullScreen
        open={props.openInputDialog}
        onClose={props.closeDialogInputDialog}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.closeDialogInputDialog}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.title}>
              Transacti Sales Invoice <br />
              <small>
                {props.selectedSalesOrder.Account
                  ? props.selectedSalesOrder.Account.account_name
                  : ""}
              </small>
            </Typography>
            <Button
              color="inherit"
              className={classes.clearInputBtn}
              onClick={clearInputClickListener}
            >
              Clear all
            </Button>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <Paper square className={classes.productListPaper}>
          {search()}
          {isLoading ? (
            <LinearProgress
              color="secondary"
              style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
            />
          ) : (
            ""
          )}
          {productLists()}
        </Paper>
        <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
          {loadProducts ? (
            <LinearProgress
              color="secondary"
              style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
            />
          ) : (
            ""
          )}
          <Toolbar>
            <Typography variant="subtitle1" noWrap>
              Total: ₱
              {Number(totalInvoicedAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <div className={classes.grow} />

            <Button
              variant="contained"
              onClick={() => {
                const temporarySalesInvoiceString = localStorage.getItem(
                  props.selectedSalesOrder.auto_generated_id + "_temporary_sales_invoice"
                );

                const totalInvoicedItemCount = totalInvoicedCount();

                if (totalInvoicedItemCount <= 0) {
                  setMessageDialogMessage("Please input quantity and price atleast in one item.");
                  setShowMessageDialog(true);
                  return;
                }

                props.openProductReviewDialogHandleClick();
              }}
            >
              <Typography variant="caption" noWrap>
                Proceed to invoice
              </Typography>
              <Badge
                badgeContent={invoicedItemCount}
                color="secondary"
                style={{ marginLeft: "1rem" }}
              />
            </Button>
          </Toolbar>
        </AppBar>
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {lotNumberAndExpirationInputDialog()}
          {messageDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default InputSalesInvoices;
